import { getPartnerConfig } from 'partnersApp/config';
import * as GA_EVENTS from './index';
import { defaultUserData } from 'rmw-shell/lib/utils/auth';

const partnerConfig = getPartnerConfig('shine');
export function init() {
  if (partnerConfig.gaEnabled) {
    var _gaq = window.dataLayer || [];
    window.GA = {};
    window.GA.trackGaEvent = function () {
      _gaq.push(arguments);
    };
    window.GA.trackGaEvent('js', new Date());
    window.GA.trackGaEvent('config', partnerConfig.gaTrackingKey);
    try {
      const queryParams = Object.fromEntries(
        new URL(window.location.href).searchParams.entries(),
      );
      if (queryParams?.candidateId) {
        // window.GA.trackGaEvent('set', 'user_properties', {
        //   candidateId: queryParams?.candidateId,
        // });

        localStorage.setItem(
          'partner:shine:candidateId',
          queryParams?.candidateId,
        );
      }
    } catch (error) {
      console.warn(error, 'Error adding query params to formData');
    }
  }
}

export function captureEvent(
  eventName,
  eventParams,
  userInfo,
  updateAuth = null,
) {
  // if (eventName === GA_EVENTS.resumeDownloadPdfClick && window.tp && userInfo) {
  //   console.log('Download_resume');
  //   const lastTPRequest = localStorage.getItem(
  //     DEMO_EDITOR_KEYS.TRUST_PILOT_REQUEST,
  //   );
  //   const { uid, email, displayName, downloadCount = 1 } = userInfo;
  //   if (!lastTPRequest) {
  //     const trustpilot_invitation = {
  //       recipientEmail: email,
  //       recipientName: displayName,
  //       referenceId: uid,
  //       source: 'InvitationScript',
  //     };
  //     if (downloadCount > 10) {
  //       window.tp('createInvitation', trustpilot_invitation);
  //       localStorage.setItem(
  //         DEMO_EDITOR_KEYS.TRUST_PILOT_REQUEST,
  //         new Date().getTime(),
  //       );
  //     }
  //   }
  //   try {
  //     if (userInfo.isAuthenticated) {
  //       const newDownloadCount = downloadCount + 1;
  //       updateUserData(userInfo.uid, { downloadCount: newDownloadCount });
  //       updateAuth &&
  //         updateAuth({
  //           ...defaultUserData(userInfo),
  //           downloadCount: newDownloadCount,
  //         });
  //     } else {
  //       eventName = eventName + '_demo';
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  // try {
  //   const candidateId = localStorage.getItem('partner:shine:candidateId');

  //   if (candidateId && typeof window.GA?.trackGaEvent === 'function') {
  //     window.GA.trackGaEvent('set', 'user_properties', {
  //       candidateId: candidateId,
  //     });
  //   }
  // } catch (error) {
  //   // console.warn('Error capturing event:', error);
  // }
  window.GA.trackGaEvent('event', eventName, eventParams);
}
